enum approveStatusREC1 {
    approve = 1, //อนุมัติ
    deferment = 2, //รอการตัดสิน
    disapprove = 3, //ไม่อนุมัติ
    minor2Week = 4, //แก้ไขเล็กน้อย (2 สัปดาห์
    minor4Week = 6, //แก้ไขเล็กน้อย (4 สัปดาห์
    postpone = 7, //ขยายเวลาพิจารณา
    approveWithComment = 8, //อนุมัติ แบบมีข้อคิดเห็น
    approveForContiueResearch = 9, //อนุมัติให้ดำเนินการวิจัยต่อเนื่อง
    approveForContiueResearchWhenEdited = 10, //อนุมัติให้ดำเนินการวิจัยต่อเนื่องเมื่อแก้ไขหรือเพิ่มเติมข้อมูลแล้ว
    intoConsideration = 11, //นำเข้าพิจารณาในที่ประชุมคณะกรรมการฯ
    acknowledgeAndDonotTakeAnyaAction = 12, //รับทราบ และไม่ต้องดำเนินการใดๆ
    improveAndFix = 13, //ให้ปรับปรุงแก้ไขระเบียบวิธีการดำเนินการวิจัย และเอกสารข้อมูลฯ
    cautionCarefully = 14, //ตักเตือนให้นักวิจัยเพิ่มความรอบคอบ
    suspensionOrTermination = 15, //ระงับโครงการวิจัยชั่วคราว (Suspension) หรือยุติโครงการวิจัยก่อนกำหนด (Termination)
    revision = 16, //แก้ไข
}

enum approveStatusREC2 {
    minor3Week = 5, //แก้ไขเล็กน้อย (3 สัปดาห์
    approve = 17, //อนุมัติ
    disapprove = 18, //ไม่อนุมัติ

    minor2Week = 19, //แก้ไขเล็กน้อย (2 สัปดาห์)
    minor4Week = 20, //แก้ไขเล็กน้อย (4 สัปดาห์)
    approveWithComment = 21, //อนุมัติ แบบมีข้อคิดเห็น
    approveForContiueResearch = 22, //อนุมัติให้ดำเนินการวิจัยต่อเนื่อง
    approveForContiueResearchWhenEdited = 23, //อนุมัติให้ดำเนินการวิจัยต่อเนื่องเมื่อแก้ไขหรือเพิ่มเติมข้อมูลแล้ว

    intoConsideration = 24, //นำเข้าพิจารณาในที่ประชุมคณะกรรมการฯ
    acknowledgeAndDonotTakeAnyaAction = 25, //รับทราบ และไม่ต้องดำเนินการใดๆ

    improveAndFix = 26, //ให้ปรับปรุงแก้ไขระเบียบวิธีการดำเนินการวิจัย และเอกสารข้อมูลฯ
    cautionCarefully = 27, //ตักเตือนให้นักวิจัยเพิ่มความรอบคอบ
    suspensionOrTermination = 28, //ระงับโครงการวิจัยชั่วคราว (Suspension) หรือยุติโครงการวิจัยก่อนกำหนด (Termination)
    revision = 29, //แก้ไข
}
export { approveStatusREC1, approveStatusREC2 }
